import React, { useContext } from 'react';
import { ScrollLink } from '@prisjakt/ui-scroll';
import BackToTopIcon from 'mdi-react/ArrowUpIcon';
import { AppContext } from '@prisjakt/ui-app-context';
import * as S from '../../styles';
import { blurActiveElement } from '../../utils';

const ProductScrollTopButton: React.FC = () => {
  const { t } = useContext(AppContext);
  return (
    <ScrollLink to="Top" onClick={blurActiveElement}>
      <S.BackToTopButton
        aria-label={t('product', 'back-to-top.button-description')}
      >
        <BackToTopIcon />
      </S.BackToTopButton>
    </ScrollLink>
  );
};
export default ProductScrollTopButton;
